import { render, staticRenderFns } from "./Colofon.vue?vue&type=template&id=112b7909"
import script from "./Colofon.vue?vue&type=script&lang=js"
export * from "./Colofon.vue?vue&type=script&lang=js"
import style0 from "./Colofon.vue?vue&type=style&index=0&id=112b7909&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports